/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Binding_Test_FailedInputs */



/**
* | output |
* | --- |
* | "Connection test failed." |
*
* @param {Integrations_Binding_Test_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_binding_test_failed = /** @type {((inputs?: Integrations_Binding_Test_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Binding_Test_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindungstest fehlgeschlagen.")
	return /** @type {LocalizedString} */ ("Connection test failed.")
});